/* eslint-disable prefer-template */

import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useFormik } from 'formik'
import * as yup from 'yup'

import { Grid, Header, Message } from "semantic-ui-react";

// material
import { styled } from "@mui/material/styles";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
} from '@mui/material'
// components
// components
import Page from '../components/Page'
import ClientMenuLeft from './common/ClientMenuLeft';
import DisplayCognitoError from '../components/common/DisplayCognitoError'
import { confirmStart } from '../redux/auth/auth.actions'
// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 1000,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(12, 0),
}));


// ----------------------------------------------------------------------

export default function AdminRegisterConfirmPage() {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { currentError } = useSelector((state) => state.authReducer)
  const validationSchemaData = yup.object({
    code: yup.string('Entrez votre code').required('Le code est requis'),
  })

  const formik = useFormik({
    initialValues: {
      code: '',
    },
    validationSchema: validationSchemaData,
    onSubmit: (values) => {
  
      const user = {
        code: values.code,
        username: localStorage.getItem('usernameConfirmAdmin'),
        navigate: navigate,
        link: '/admin'
      }
      dispatch(confirmStart(user))
    },
  })
  return (
    <RootStyle title="Register | Gestion des plaintes">
    <ClientMenuLeft />
      <Container>
        <ContentStyle>
          {" "}
          <Grid textAlign="center" verticalAlign="middle">
            <Grid.Column style={{ maxWidth: 450 }}>
              <Header as="h2" color="blue" textAlign="center">
              Validation de votre compte
              </Header>

              <>
              <form onSubmit={formik.handleSubmit}>
                <Box sx={{ my: 3 }}>
                  <Typography color="textPrimary" variant="h4">
                    Confirmer votre inscription
                  </Typography>

                  <Message info>
                    Le code de vérification a été envoyé à votre adresse e-mail:{' '}
                    {localStorage.getItem('usernameConfirmAdmin')}
                    <p>
                      Le code expire dans 1 heure et ne peut être utilisé qu'une
                      seule.
                    </p>
                    fois
                  </Message>
                </Box>
                <DisplayCognitoError errorMessage={currentError} />
                <TextField
                  error={Boolean(formik.touched.code && formik.errors.code)}
                  fullWidth
                  helperText={formik.touched.code && formik.errors.code}
                  label="Code"
                  margin="normal"
                  name="code"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.code}
                  variant="outlined"
                />

                <Box sx={{ py: 2 }}>
                  <Button
                    color="secondary"
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Confirmer
                  </Button>
                </Box>
              </form>
              </>
            </Grid.Column>
          </Grid>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
